export default function getGenericDataId(classnames = '') {
    return classnames.split(' ').reduce((prev, cur, idx, arr) => {
        let text

        if (cur.charAt(0) === 'x') {
            text = 'x'
        } else if (cur.indexOf('--') > -1) {
            text = cur.substring(0, cur.indexOf('--'))
        } else {
            text = cur
        }
        if (idx < arr.length - 1) {
            text += '-'
        }
        return prev + text
    }, '')
}
